<template>
  <div class="ProjectContent ">
    <video  autoplay loop muted playsinline>
      <source  :src="video_src2" type="video/mp4" key="2">
    </video>
    <div class="bg_filter"></div>
      <transition appear name="pageTitle">
        <div class="content-header">
          <h1>STAGE</h1>
        </div>
      </transition>
      <div class="grid-wrapper">
        <div class="grid-items" v-for="(img, index ) in items" v-bind:key="index">
           <router-link :to="img.link">
              <div v-if="img.isUse ===  1" class="item item-card" :style="{'background-image': 'url(' + img.path + ')' , 'background-size':'cover', 'background-position':'center'}">
              </div>
              <div v-if="img.isUse ===  2" class="item item-card" :style="{'background-image': 'url(' + img.path + ')' , 'background-size':'cover', 'background-position':'center'}">
                <div class="stage-top-left">
                  <p>{{img.pref}}</p>
                </div>
                <div class="stage-center">
                  <p >{{img.discription}}</p>
                </div>
                <div class="stage-bottom-right">
                  <p >{{img.title}}</p>
                </div>
              </div>
              <div v-if="img.isUse ===  0" class="item item-card item-title" >
                  <p>{{img.title}}</p>
                  <h3>{{img.discription}}</h3>
                  <p><span>{{img.pref}}</span><span>{{img.place}}</span></p>

                  <img :src="img.path" :alt="img.title" class="stage-imges">

              </div>
           </router-link>
        </div>
    </div>
    <div class="content-footer">
        <div class="footer-menu">
          <router-link to="/">
          <h3>HOME</h3>
          <p>2018 TOURdeHDR+ COLLECTION</p>
          <p>STAGE 1 - 11</p>
          </router-link>
        </div>
        <div class="footer-menu">
          <router-link to="/project">
          <h3>STAGE</h3>
          <p>It is the main picture of the stage</p>
           </router-link>
        </div>
        <div class="footer-menu">
           <router-link to="/awards">
          <h3>AWARDS</h3>
          <p>I picked up a good picture of the year</p>
          </router-link>
        </div>
      </div>
      <div class="sns-footer">
        <a href="https://twitter.com/TOURdeHDR" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-twitter-square"></i></div>
        </a>
        <a href="https://www.instagram.com/yoshiak_hiramatsu_hdr/?hl=ja" target="_blank">
          <div class="sns-item"><i class="fab fa-3x fa-instagram"></i></div>
        </a>
        <a href="http://tourdehdr.sakuratan.com/site2/" target="_blank">
          <div class="sns-item">
             <svg version="1.1" id="レイヤー_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                y="0px" viewBox="0 0 1280 1024" style="enable-background:new 0 0 1280 1024;" xml:space="preserve">

                <g>
                  <path class="st0" d="M447,779c-16,0-29-13-29-29V312c0-16,13-29,29-29h438c16,0,29,13,29,29v438c0,16-13,29-29,29H447z"/>
                  <path d="M885,285c14.9,0,27,12.1,27,27v438c0,14.9-12.1,27-27,27H447c-14.9,0-27-12.1-27-27V312c0-14.9,12.1-27,27-27H885 M885,281
                    H447c-17.1,0-31,13.9-31,31v438c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31V312C916,294.9,902.1,281,885,281L885,281z"/>
                </g>
                <g>
                  <path d="M570.1,312.4v237.2h-61.7V450H490v99.6h-61.7V312.4H490v84.8h18.5v-84.8H570.1z"/>
                </g>
                <g>
                  <path class="st1" d="M595.4,378.5h46.1c29.8,0,49.9,1.4,60.4,4.1c10.5,2.7,18.5,7.2,24,13.5c5.5,6.3,8.9,13.2,10.3,20.9
                    c1.4,7.7,2.1,22.7,2.1,45.2v83.1c0,21.3-1,35.5-3,42.7c-2,7.2-5.5,12.8-10.5,16.8c-5,4.1-11.1,6.9-18.5,8.5s-18.4,2.4-33.1,2.4
                    h-77.8V378.5z M657.1,419.1v156c8.9,0,14.4-1.8,16.4-5.3c2.1-3.6,3.1-13.3,3.1-29.1v-92.1c0-10.7-0.3-17.6-1-20.7
                    c-0.7-3-2.2-5.2-4.7-6.7C668.4,419.8,663.8,419.1,657.1,419.1z"/>
                </g>
                <g>
                  <path class="st2" d="M766.7,444.7h43.7c29.1,0,48.8,1.1,59.1,3.4c10.3,2.2,18.7,8,25.2,17.2c6.5,9.2,9.7,24,9.7,44.2
                    c0,18.5-2.3,30.9-6.9,37.2c-4.6,6.3-13.6,10.2-27.1,11.4c12.2,3,20.4,7.1,24.6,12.2c4.2,5.1,6.8,9.7,7.8,14s1.5,15.9,1.5,35.1v62.5
                    h-57.3V603c0-12.7-1-20.6-3-23.6c-2-3-7.3-4.5-15.7-4.5v106.9h-61.7V444.7z M828.4,485.2V538c6.9,0,11.8-1,14.6-2.9
                    s4.2-8.1,4.2-18.5v-13c0-7.5-1.3-12.5-4-14.8C840.4,486.4,835.5,485.2,828.4,485.2z"/>
                </g>
                <g>
                  <rect x="342" y="1159" width="583" height="129"/>
                </g>
                <g>
                  <path d="M416,690v60c0,17.1,13.9,31,31,31h438c17.1,0,31-13.9,31-31v-60H416z"/>
                </g>
              </svg>
          </div>
        </a>
      </div>
      <div class="sns-footer">
          <div class="sns-item"><i class="fas fa-copyright">TOURdeHDR</i></div>
      </div>
      
  </div>
</template>

<script>
export default {
  name: 'projectContent',
  props: {
    msg: String
  },
  data() {
    return {
      video_src1: require("../assets/img/Indian Tea.mp4"),
      video_src2: require("../assets/img/Painting960.mp4"), 
      video_src3: require("../assets/img/Night-Traffic.mp4"),
      isTitle: true,
      // img: "../assets/img/tokyo/img1482b.jpg",
      // imgurl: require("../assets/img/tokyo/img1482b.jpg"),
      
      items: [
      {no:100, path: require('../assets/img/hdr/universal960x640.jpg'), isUse:0, pref:'大阪', place:'USJ',  discription:'ユニバーサルシティーウォーク',  title:'STAGE1',  link:'/Stage1'},
      {no:101, path: require('../assets/img/hdr/img6642.jpg'), isUse:1, pref:'大阪', place:'USJ',  discription:'ユニバーサルシティーウォーク',  title:'STAGE1',  link:'/Stage1'},
     
     
      {no:200, path: require('../assets/img/hdr/gion_title1.jpg'), isUse:0, pref:'大阪', place:'築港',  discription:'ENSU CAR',  title:'STAGE2',  link:'/Stage2'},
      {no:201, path: require('../assets/img/hdr/img6095.jpg'), isUse:1, pref:'大阪', place:'築港',  discription:'ENSU CAR',  title:'STAGE2',  link:'/Stage2'},
      
      {no:300, path: require('../assets/img/hdr/festival_title2.jpg'), isUse:0, pref:'大阪', place:'USJ',  discription:'FESTIVAL TOWER WEST',  title:'STAGE3',  link:'/Stage3'},
      {no:301, path: require('../assets/img/hdr/img5525.jpg'), isUse:1, pref:'東京', place:'Ako',  discription:'FESTIVAL TOWER WEST',  title:'STAGE3',  link:'/Stage3'},
      
      {no:400, path: require('../assets/img/hdr/hinase_title3.jpg'), isUse:0, pref:'岡山', place:'日生',  discription:'HINASE',  title:'STAGE4',  link:'/Stage4'},
      {no:401, path: require('../assets/img/hdr/img4776.jpg'), isUse:1, pref:'岡山', place:'日生',  discription:'HINASE',  title:'STAGE4',  link:'/Stage4'},
      
      {no:500, path: require('../assets/img/hdr/img7718_titleMini.jpg'), isUse:0, pref:'大阪', place:'梅田',  discription:'空中庭園',  title:'STAGE5',  link:'/Stage5'},
      {no:501, path: require('../assets/img/hdr/img7457.jpg'), isUse:1, pref:'大阪', place:'梅田',  discription:'空中庭園',  title:'STAGE5',  link:'/Stage5'},
      
      {no:600, path: require('../assets/img/hdr/akouganngu_title7.jpg'), isUse:0, pref:'兵庫', place:'赤穂',  discription:'赤穂玩具博物館',  title:'STAGE6',  link:'/Stage6'},
      {no:601, path: require('../assets/img/hdr/img4605.jpg'), isUse:1, pref:'兵庫', place:'赤穂',  discription:'赤穂玩具博物館',  title:'STAGE6',  link:'/Stage7'},
      
      {no:700, path: require('../assets/img/hdr/img9697_title6.jpg'), isUse:0, pref:'香川', place:'三豊',  discription:'父母ヶ浜',  title:'STAGE7',  link:'/Stage7'},
      {no:701, path: require('../assets/img/hdr/img9856a.jpg'), isUse:1, pref:'香川', place:'三豊',  discription:'父母ヶ浜',  title:'STAGE7',  link:'/Stage7'},
      
      {no:800, path: require('../assets/img/hdr/img4122_title1.jpg'), isUse:0, pref:'兵庫', place:'赤穂',  discription:'赤穂城跡',  title:'STAGE8',  link:'/Stage8'},
      {no:801, path: require('../assets/img/hdr/img3882.jpg'), isUse:1, pref:'兵庫', place:'赤穂',  discription:'赤穂城跡',  title:'STAGE8',  link:'/Stage8'},
      
      {no:900, path: require('../assets/img/hdr/fukuyamajyou_title11.jpg'), isUse:0, pref:'広島', place:'福山',  discription:'福山城公園',  title:'STAGE9',  link:'/Stage9'},
      {no:901, path: require('../assets/img/hdr/img9106.jpg'), isUse:1, pref:'広島', place:'福山',  discription:'福山城公園',  title:'STAGE9',  link:'/Stage9'},
      
     
      {no:1000, path: require('../assets/img/hdr/sc2_title1.jpg'), isUse:0, pref:'大阪', place:'',  discription:'OSAKA CHIPS2',  title:'STAGE10',  link:'/Stage10'},
      {no:1001, path: require('../assets/img/hdr/img1248.jpg'), isUse:1, pref:'大阪', place:'',  discription:'OSAKA CHIPS2',  title:'STAGE10',  link:'/Stage10'},
     
      {no:1100, path: require('../assets/img/hdr/BrightChristmas.jpg'), isUse:0, pref:'東京', place:'',  discription:'BRIGHT CHRISTMAS',  title:'STAGE11',  link:'/Stage11'},
      {no:1101, path: require('../assets/img/hdr/img0748.jpg'), isUse:1, pref:'東京', place:'',  discription:'BRIGHT CHRISTMAS',  title:'STAGE11',  link:'/Stage11'},
     
      {no:1200, path: require('../assets/img/hdr/awards2018mozaiku_white.jpg'), isUse:0, pref:'AWARDS', place:'',  discription:'AWARDS',  title:'STAGE12',  link:'/Awards'},
      // {no:1201, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-TITLE',  discription:'ステージタイトル',  title:'STAGE12',  link:'/stage12'},
      
       // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-TWILIGHT',  discription:'夕暮れ',  title:'TWILIGHT',  link:'/stage1'},
      // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-NIGHT',  discription:'夜景',  title:'TWILIGHT',  link:'/stage1'},
      // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-VEHICLE',  discription:'乗り物',  title:'TWILIGHT',  link:'/stage1'},
      // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-NATURE',  discription:'夕景コレクション',  title:'TWILIGHT',  link:'/stage1'},
      // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-STRUCTURE',  discription:'夕景コレクション',  title:'TWILIGHT',  link:'/stage1'},
      // {no:1, path: require('../assets/img/hdr/img6642.jpg'), isUse:2, pref:'COLLECTION', place:'-TOURIST SPOT',  discription:'夕景コレクション',  title:'TWILIGHT',  link:'/stage1'},
    ] 
    }
  },
  // created() {
  // },
  // mounted: function(){

      // window.addEventListener("DOMContentLoaded", this.handleLoad);
        // this.loading = true;
        // this.getUnits()
  // },
  // methods: {
    // handleLoad() {
    //    console.log("All resources finished loading!");
    // }
    // getUnits: function() {
      // console.log("getUnits!");
      // setTimeout(() => {
      //   this.loading = false;
      // }, 1500);
    // },
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
//  @import "../assets/scss/page/ProjectComponent.scss";
.ProjectContent{
  width: 100%;
  height: 100%;
  text-align: center;
  padding: auto 0;
}
.load-containt{
  width: 100vw;
  height: 100vh;
  display: flex;
 
  background-color: #9b2727;
  z-index: 1000;
}
.title{
  width: 20rem;
  height: 3rem;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  margin: auto;
}

//header
.content-header{
  position: relative;
  width: 100%;
  height: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.content-header .select-menu{
  position: absolute;
  top: 10rem;
  left: 0;
}
.content-header .select-menu ul{
  margin: 1rem;
}
.content-header .select-menu .select-menu-label{
  font-size: .6rem;
  margin: 0 .5rem;
  vertical-align: bottom;
}
.content-header h1{
    letter-spacing:1.5rem; 
}

.content-footer{
  position: relative;
  width: 100vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  @media (min-width:992px) {
    justify-content: space-around;
    flex-direction: row;
  }
}
.footer-menu{
  width: 100%;
  padding: 1rem;
  text-align: center;
  h3{
      font-size: 3rem;
    }
    p{
     font-size: 1rem; 
    }
  
  @media (min-width:992px) {
    text-align: left;
    width: 25%;
   h3{
      font-size: 3rem;
    }
    p{
     font-size: 1.5rem; 
    }
  }
}
.sns-footer{
  position: relative;
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sns-item{
  text-align: center;
  margin: 0 ;
     font-size: .5rem; 
     @media (min-width:992px) {
      font-size: 1rem;  
    }
    i{
      margin: 0 2rem;
    }
}
//gulid
.grid-wrapper{
  position: relative;
  margin: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  grid-template-columns: repeat(2, 1fr)  ;
  margin: 0px;
  @media (min-width:768px) {
   display: grid;
   grid-gap: 2px;
   grid-template-columns: repeat(2, 1fr) ;
  }
  @media (min-width:1440px) {
   display: grid;
   grid-template-columns: repeat(4, 1fr) ;
  }
  @media (min-width:2560px) {
   display: grid;
   grid-template-columns: repeat(6, 1fr) ;
  }
}
// .grid-wrapper > div {
//   border: 1px solid rgba(250,250,250,.2);
// }
.item{
  overflow:hidden;
  text-align: left;
  grid-column: span 2;
  width: 100%;
   height:80vh;
   @media (min-width:768px) {
   height: 80vh;
  }
   @media (min-width:1440px) {
   height: 60vh;
  }
   @media (min-width:2560px) {
   height: 70vh;
  }
}
.item-img{
  width: 100%;
  height: auto;
}
.item-card{
  position:relative;
  padding: .5rem 1rem;
  border: 1px solid rgba(250,250,250,.2);
}
.item-title{
  transition: all ease-in .5s;
  &:hover{
    transition: all ease-in .5s;
    background-color: rgba(250,250,250,.3);
    .stage-imges{
      transition: all ease-in .5s;
      transform: scale(0.95)
    }
  }

}
.stage-imges{
  transition: all ease-in .5s;
  width: 100%;
  height: auto;
  display: inline-block;
  margin: 5rem auto 0 0;
}
.stage-center{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(0,0,0,.6);
  color: #fff;
  padding: .5rem;
  width: 90%;
  text-align: center;
  p{
    font-size: .8rem;
    font-weight: 700;
    letter-spacing: .8rem;
  }
}
.stage-bottom-right{
  position: absolute;
  bottom: 1rem;
  right:1rem;
  background-color: rgba(0,0,0,.6);
  border: 1px solid #fff;
  padding: .1rem .5rem;
  text-align: center;
  p{
    font-size: .8rem;
    font-weight: 700;
  }
}
.stage-top-left{
  position: absolute;
  top: 1rem;
  left: 1rem;
  background-color: rgba(0,0,0,.6);
  border: 1px solid #fff;
  text-align: center;
  padding: .1rem .5rem;
  text-align: center;
   p{
    font-size: .8rem;
    font-weight: 700;
  }
}
.item-left{
  text-align: left;
}
.item-center{
  text-align: center;
}
.item-right{
  text-align: right;
}

.item2{
  @media (min-width:500px) {
    width: 100%;
    grid-column: span 2;
  }
}
.item3{
  @media (min-width:500px) {
    width: 100%;
    grid-column: span 2;
  }
}
.item8{
  @media (min-width:768px) {
    width: 100%;
    grid-column: span 5;
    grid-row: span 3;
  }
}
.item18{
  @media (min-width:768px) {
    width: 100%;
    grid-column: span 3;
    grid-row: span 2;
  }
}


video {
  position: fixed;
  top: 0%;
  left: 0%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: -2;
}
.bg_filter{
    background-color: rgba(0,0,0,.5);
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
}
svg{
  width: 60px;
  height: 60px;
  margin: 0rem;
  @media (min-width:992px) {
    width: 110px;
    height: 110px;
    margin: 0rem;
  }

}
.st0{
  fill:#FFFFFF;
  &:hover{
    fill:rgb(93, 226, 60);
  }
  }
.st1{fill:#333333;}
.st2{fill:#666666;}
</style>
